<template>
  <div class="row">
    <div class="col-12">
      <filter-component @getGroupBy="getGroupBy" />
      <main-chart v-if="items.length" class="mb-4" />
      <a-s-r-chart v-if="items.length" class="mb-4" />
      <a-c-d-chart v-if="items.length" class="mb-4" />
      <table-component :filter_items="filter_items" />
    </div>
  </div>
</template>

<script>
  import FilterComponent from './voice-stats-general-table-filter';
  import MainChart from './voice-stats-general-chart-main';
  import ASRChart from './voice-stats-general-chart-asr';
  import ACDChart from './voice-stats-general-chart-acd';
  import TableComponent from './voice-stats-general-table';
  import { mapGetters } from 'vuex';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      FilterComponent,
      MainChart,
      TableComponent,
      ASRChart,
      ACDChart
    },

    data() {
      return {
        group_by: '',
        filter_items: null
      }
    },

    computed: {
      ...mapGetters('voice/stats/general', { items: DATA })
    },

    watch: {
      items: {
        handler: function() {
          if( !(this.group_by == 'country') ) {
            this.filter_items = null;
            return false;
          }
          this.filter_items = this.items.map(item => ({ ...item }));
          Object.keys(this.filter_items).map(key => {this.filter_items[key].group_by = this.$t(`voice.iso.code.${this.filter_items[key].group_by}`) });
        },
        immediate: true
      }
    },

    methods: {
      getGroupBy(data) {
        this.group_by = data;
      }
    }
  };
</script>
